import React, { useEffect, useState } from 'react'

import { observer } from 'mobx-react-lite'

import _ from 'lodash'
import { $auth } from 'ziphy-web-shared/basic/entities/auth'
import { $patients } from 'ziphy-web-shared/basic/entities/patients'
import { WithLoaderWrapper } from 'ziphy-web-shared/basic/lib/loaders'
import { useLoaderSubscribe } from 'ziphy-web-shared/basic/utils'
import { $router } from 'ziphy-web-shared/basic/utils/router'

import { $liveqBooking } from '@store'

import { routeActions } from '@config/routeActions'

import { bookingSchema } from '../../config/bookingSchema'
import { useLoader } from 'ziphy-web-shared/basic/hooks'
import { useParams } from 'react-router-dom'

const withSurveyDataLoad = (WrappedComponent) => {
  const withSurveyDataLoad = ({ ...props }) => {
    const { surveyId, token } = useParams();

    const {isLoading} = useLoader(async () => {
      await $liveqBooking.load(surveyId, token)
    })

    // TODO uncomment when url upload will be ready
    // const searchParams = useRouterSearchParams('replace')
    // useEffect(() => {
    //   searchParams.set($booking.searchParams)
    // }, [$booking.searchParams])


    return (
      <WithLoaderWrapper
        isLoading={isLoading}
        loaderMode={props.loaderMode ? props.loaderMode : 'pageWrapper'}
        withWrapper={false}
      >
        <WrappedComponent {...props} />
      </WithLoaderWrapper>
    )
  }

  withSurveyDataLoad.displayName = `withSurveyDataLoad(${WrappedComponent.displayName || WrappedComponent.name})`

  return observer(withSurveyDataLoad)
}

export default withSurveyDataLoad
